import { getDefaultFilters } from '../selectors/productSelector';

const product = {
    hasLiveStockFilter:
        typeof window.hasLiveStockFilter != 'undefined'
            ? window.hasLiveStockFilter
            : false,
    hasInitialized: false,
    isLoading: false,
    categoryTree: {},
    list: {},
    listDisplay: [],
    listParams: {
        filters: getDefaultFilters(),
        activePage: 1,
        perPage: 60,
        totalRecords: 1,
        sortBy: typeof window.q != 'undefined' ? '' : '',
        sortDirection: typeof window.q != 'undefined' ? '' : '',
    },
    viewType: 'grid',
};
const ProductReducer = function(state = product, action) {
    switch (action.type) {
        case 'UPDATE_PRODUCT_LIST_HAS_INITIALIZED': {
            return {
                ...state,
                hasInitialized: action.value,
            };
        }
        case 'TOGGLE_PRODUCT_LIST_LOADING': {
            return {
                ...state,
                isLoading: action.value,
            };
        }
        case 'UPDATE_PRODUCT_LIST': {
            let newList = { ...state.list };

            Object.entries(action.value).map(([key, value]) => {
                newList[key] = {
                    ...newList[key],
                    ...value,
                };
            });

            return {
                ...state,
                list: newList,
            };
        }
        case 'REPLACE_PRODUCT_LIST': {
            return {
                ...state,
                list: action.value,
            };
        }
        case 'REPLACE_PRODUCT_CATEGORIES_TREE': {
            return {
                ...state,
                categoryTree: action.value,
            };
        }
        case 'UPDATE_PRODUCT_LIST_DISPLAY': {
            return {
                ...state,
                listDisplay: action.value,
            };
        }
        case 'UPDATE_PRODUCT_LIST_VIEW_TYPE': {
            return {
                ...state,
                viewType: action.value,
            };
        }
        case 'UPDATE_PRODUCT_LIST_FILTERS': {
            return {
                ...state,
                listParams: {
                    ...state.listParams,
                    filters: action.value,
                },
            };
        }
        case 'UPDATE_PRODUCT_LIST_SORT': {
            return {
                ...state,
                listParams: {
                    ...state.listParams,
                    sortBy: action.value,
                    sortDirection: action.direction,
                },
            };
        }
        case 'SET_PRODUCT_LIST_ACTIVE_PAGE': {
            return {
                ...state,
                listParams: {
                    ...state.listParams,
                    activePage: action.value,
                },
            };
        }
        case 'SET_PRODUCT_LIST_TOTAL_RECORDS': {
            return {
                ...state,
                listParams: {
                    ...state.listParams,
                    totalRecords: action.value,
                },
            };
        }
        default: {
            return state;
        }
    }
};

export default ProductReducer;
